import type { COLOR } from '@george-labs.com/design-system/types/utilsTS/color';
import type { ReactNode } from 'react';

import type { Amount, SignInfo } from '@shared/core-types';

interface Product {
    id: string;
    alias?: ReactNode;
    icon: string;
    productI18N?: string;
    productNumber?: ReactNode;

    imageUrl?: string;
    color?: COLOR;
    balance?: Amount;
}

export interface WatchdogProduct extends Product {
    checked: boolean;
}

export enum WatchdogGroup {
    Basic = 'BASIC',
    ProductOriented = 'PRODUCT_ORIENTED',
    Regulations = 'REGULATIONS',
    Marketing = 'MARKETING',
}

export enum Status {
    Active = 'ACTIVE',
    Inactive = 'INACTIVE',
}

export enum WatchdogType {
    Balance = 'BALANCE_WD',
    Cards = 'CARDS',
    IncomingTrx = 'INCOMING_TRX',
    OutgoingTrx = 'OUTGOING_TRX',
    Misc = 'MISC',
    Reg924 = 'REG_924',
    OrderStatus = 'SECURITIES_ORDER_STATUS',
    QuotationAlert = 'SECURITIES_QUOTATION_ALERT',
    InstantPayment = 'INSTANT_PAYMENT',
    RequestToPay = 'REQUEST_TO_PAY',
    Crm = 'CRM',
    RegAuth = 'REG_AUTH',
    RegEChannel = 'REG_E_CHANNEL',
    RegCards = 'REG_CARDS',
}

export enum EligibleProductSource {
    Cards = 'CARDS',
    Accounts = 'ACCOUNTS',
}

export enum Channel {
    SMS = 'SMS',
    EMAIL = 'EMAIL',
    Push = 'PUSH',
    George = 'GEORGE',
}

export enum TriggerCriterionIdentifier {
    AMOUNT_FIELD = 'AMOUNT_FIELD',
    KEYWORD_SEARCH = 'KEYWORD_SEARCH',
    DATE_FROM = 'DATE_FROM',
    DATE_TO = 'DATE_TO',
}

export enum TriggerCriterionType {
    AMOUNT = 'AMOUNT',
    TEXT = 'TEXT',
    DATE = 'DATE',
}

export interface AlertChannel {
    channel: Channel;
    status: Status;
    contactValue?: string;
    contactId?: string;
    flags?: AlertChannelFlag[];
}

export interface EligibleProduct {
    id: string;
    source: EligibleProductSource;
    status: Status;
    flags?: string[];
}

export enum WatchdogFlag {
    'CONTACTS_IDS_USAGE' = 'contactsIdsUsage',
    'CONTACTS_VALUES_USAGE' = 'contactsValuesUsage',
    'NO_PRODUCTS_AVAILABLE' = 'noProductsAvailable',
    'NO_STATUS_OPTIONS' = 'noStatusOptions',
    'NO_SETTINGS_OPTIONS' = 'noSettingsOptions',
    'NO_PRODUCTS_ALLOCATION' = 'noProductsAllocation',
}

export interface Watchdog {
    id: string;
    alertChannels: AlertChannel[];
    eligibleProducts?: EligibleProduct[];
    flags?: string[];
    group: WatchdogGroup;
    status: Status;
    type: WatchdogType;
    signInfo?: SignInfo;
    triggerCriteria?: WatchdogTriggerCriterion[];
}

export interface ChannelSelection {
    channel: Channel;
    value?: string;
}

export interface WatchdogTriggerCriterion {
    identifier: TriggerCriterionIdentifier;
    status: Status;
    type: TriggerCriterionType;
    amount: Amount;
}

export enum AlertChannelFlag {
    CHANGE_NOT_ALLOWED = 'changeNotAllowed',
}
